<template>
    <div>
        <div class="footer_lh"></div>
        <div class="fxboex footer">
            <div class="footer_nav">
                <ul>
                    <li v-for="(item,i) in navList" :key="i">
                        <div :class="['ft', item.url === $route.path?' curr':'']" :to="item.url" @click="goView(i)">
                            <i :class="'icon'+i"></i>
                            <span>{{item.name}}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="fxcar" v-if="user">
            <span v-if="user.cart>0">{{user.cart}}</span>
            <router-link to="/cart"></router-link>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "Footer",
    computed: mapGetters(['user']),
    data(){
        return {
            navList: [
                {name: '首页', url: '/'},
                {name: '免费', url: '/free'},
                {name: '预测', url: '/ball'},
                {name: '专家', url: '/expert'},
                {name: '会员', url: '/my'},
            ]

        }
    },
    created() {
        //console.log(2)
        // this.getNotice()
    },
    methods: {
        goView(i){
            let path = this.navList[i].url
            this.$router.replace({path: path})
        }
        // getNotice(){
        //     let that = this
        //     setInterval(function () {
        //         let notice = 0
        //         if (that.$store.state.token != null) {
        //             that.$post(that.$api.getnotice).then(function (res) {
        //                 // console.log(res)
        //                 if (res.code === 1) {
        //                     // console.log(notice)
        //                     notice = res.data.notice_count
        //                 }
        //                 that.$store.commit('SET_NOTICE', notice)
        //                 that.notice = notice
        //             })
        //         }
        //         else{
        //             that.$store.commit('SET_NOTICE', notice)
        //             that.notice = notice
        //         }
        //     }, 1000 * 60 * 2)
        // }
    }
}
</script>

<style scoped>
</style>
